export const defaultDropdownConfig = {
  pageIndex: 1,
  pageSize: 200,
  searchString: ""
};

export const formatDate = (dateString) => {
  const options = { year: '2-digit', month: '2-digit', day: '2-digit' };
  return new Date(dateString).toLocaleDateString('en-GB', options);
};

export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export const EmployeeData = [
  "firstName",
  "lastName",
  "email",
  "email2",
  "email3",
  "mobileNumber",
  "learnerId",
];
